"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tile = void 0;
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledTile = styled_components_1.default.button `
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color:  ${({ theme }) => theme.white};
	border: ${({ theme }) => `2px solid ${theme.lightGray2}`};
	border-radius: 3px;
	width: 200px;
	height: 100%;
	min-height: 160px;
	margin: 8px;

	&:hover, &:focus {
		border-color: ${({ theme }) => theme.pacificBlue};
		cursor: pointer;
	}

	svg.assessmentIcons {
		color: ${({ theme }) => theme.denimBlue};
		width: 76px;
		height: 76px;
	}

	@media (max-width: 41em) {
		margin-left: auto;
		margin-right: auto;
		width: 100%;
		max-width: 200px;
	}
`;
const Img = styled_components_1.default.span `
	width: 180px;
	height: 100px;
	padding: 0;
	display: block;

	@media (max-width: 41em) {
		width: 140px;
		height: 80px;
	}

	img {
		position: relative;
		top: 50%;
		transform: translateY(-50%);
		max-width: 80%;
		max-height: 80%;
	}
`;
const Text = styled_components_1.default.span `
	height: auto;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	span {
		font-size: 1rem;
		font-weight: ${({ theme }) => theme.fontLight};
		color: ${({ theme }) => theme.textBlack2};
		margin: 10px;
	}
`;
;
const Tile = ({ onClick, option, dataTestId, icon }) => {
    return (react_1.default.createElement(StyledTile, { onClick: () => onClick(option.id), "data-testid": dataTestId },
        option.image && (react_1.default.createElement(Img, null,
            react_1.default.createElement("img", { src: option.image, alt: '' }))),
        !!icon && react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "assessmentIcons", icon: icon }),
        react_1.default.createElement(Text, null,
            react_1.default.createElement("span", null, option.name_friendly || option.name || option.label))));
};
exports.Tile = Tile;
